<script>
import { cloneDeep, groupBy, orderBy } from "lodash";
import Swal from "sweetalert2";
import RawData from "@/components/widgets/raw-data.vue";
import LibPreReportBtn from '@/components/widgets/lib-pre-report-button.vue';
export default {
    name: 'posted-opcr',
    props: {
        items: Array,
        campusBusy: Boolean,
        forApproval: Boolean,
    },
    components: {
        RawData,
        LibPreReportBtn
    },
    computed: {
        filtered() {
            let data = this.items;
            if (this.filterDUs.trim() != "" && this.filterDUs) {
                data = data.filter((item) => {
                    return item.deliveryUnit.name
                        .toUpperCase()
                        .includes(this.filterDUs.toUpperCase());
                });
            }
            return data;
        },
        filteredOPCR() {
            let data = this.opcrs;
            if (this.searchOPCR.trim() != "" && this.searchOPCR) {
                data = data.filter((item) => {
                    return item.title
                        .toUpperCase()
                        .includes(this.searchOPCR.toUpperCase());
                });
            }
            return data;
        },
    },
    data() {
        return {
            filterDUs: '',
            selectedDU: null,
            searchOPCR: '',
            opcrs: [],
            selectedOPCR: null,
            selectedTab: 0,
            libs: [],
            loadLib: false,
        }
    },
    methods: {
        viewOPCRs(row) {
            this.searchOPCR = '';
            this.selectedDU = row;
            this.libs = [];
            row.libs = [];
            row.showLibs = false;
            row.showApis = true;
            this.opcrs = cloneDeep(row.opcrs);
        },
        async viewApis(row) {
            row.showApis = !row.showApis;
            row.showLibs = false;
            if (row.showApis && row.apis.length == 0) {
                row.loadApi = true;
                await this.getApis(row);
                row.loadApi = false;
            }
        },
        async viewLibs(row) {
            row.showLibs = !row.showLibs;
            row.showApis = false;
            if (row.showLibs && row.libs.length == 0) {
                row.loadLib = true;
                await this.getLibs(row);
                row.loadLib = false;
            }
        },
        // async getLibs(y){
        //     await this.$store
        //         .dispatch("financeTemplate/getBudgetItemByOPCR", y.id)
        //         .then((res) => {
        //             if(res.data.error){
        //                 return this.showToast(res.data.errorMessage, 'error')
        //             }
        //             res.data.forEach((item) => {
        //                 item.fundClass =
        //                     item.financeTemplateObjectOfExpenditure.accountGroup.fundClassification.classification;
        //                 item.fundSource =
        //                     item.financeTemplateObjectOfExpenditure.financeTemplate.fundSource.sourceName;
        //                 item.accountGroup =
        //                     item.financeTemplateObjectOfExpenditure.accountGroup.groupName;
        //             });
        //             var groupedFS = groupBy(res.data, "fundSource");
        //             var grouped = [];
        //             var id = 1;
        //             var FCID = 1;
        //             for (const key in groupedFS) {
        //                 var sumBalance = 0;
        //                 var sumAllocated = 0;
        //                 groupedFS[key].forEach((a) => {
        //                     sumBalance += a.balance;
        //                     sumAllocated += a.amount;
        //                 });
        //                 var group = groupBy(groupedFS[key], "fundClass");
        //                 var FC = [];
        //                 for (const y in group) {
        //                     FC.push({
        //                         id: FCID++,
        //                         data: group[y],
        //                         key: y,
        //                     });
        //                 }
        //                 grouped.push({
        //                     id: id++,
        //                     fsName: key,
        //                     data: FC,
        //                     balance: sumBalance,
        //                     allocated: sumAllocated,
        //                     fsId: FC[0].data[0]
        //                         .financeTemplateObjectOfExpenditure.financeTemplate
        //                         .fundSourceId,
        //                     financeTemplateId:
        //                         FC[0].data[0].financeTemplateObjectOfExpenditure
        //                             .financeTemplateId,
        //                 });
        //             }
        //             y.libs = grouped;
        //         })
        //         .catch(() => {
        //             this.showToast("Something went wrong!", "error");
        //         });
        // },
        async getDULibs(du) {
            await this.$store
                .dispatch("financeTemplate/getDeliveryUnitFunds", { cycle: this.$store.state.data.cycle, deliveryUnitId: du.deliveryUnitId })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, 'error')
                    }
                    res.data.forEach((item) => {
                        item.fundClass = item.fundClassification.classification;
                        item.fundSource = item.sourceName;
                        item.accountGroup = item.groupName;
                    });
                    var groupedFS = groupBy(res.data, "fundSource");
                    var grouped = [];
                    var id = 1;
                    var FCID = 1;
                    for (const key in groupedFS) {
                        var sumBalance = 0;
                        var sumAllocated = 0;
                        var sumDepartmentAlloc = 0;
                        groupedFS[key].forEach((a) => {
                            sumBalance += a.balance;
                            sumAllocated += a.amount;
                            sumDepartmentAlloc += a.cascadedFunds;
                        });
                        var group = groupBy(groupedFS[key], "fundClass");
                        var FC = [];
                        for (const y in group) {
                            FC.push({
                                id: FCID++,
                                data: orderBy(group[y], ['accountGroup'], ['asc']),
                                key: y,
                                allowAdd: group[y][0].allowAdd,
                            });
                        }
                        grouped.push({
                            id: id++,
                            fsName: key,
                            data: orderBy(FC, ['key'], ['asc']),
                            balance: sumBalance,
                            allocated: sumAllocated,
                            departmentAlloc: sumDepartmentAlloc,
                            fsId: FC[0].data[0].fundSourceId,
                            financeTemplateId: FC[0].data[0].financeTemplateId,
                        });
                    }
                    this.libs = grouped;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        async getApis(y) {
            await this.$store
                .dispatch("planningapi/GetPlanningApisByOPCR", y.id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, 'error')
                    }
                    res.data.forEach((x) => {
                        x.viewResource = false;
                        x.resourceList = [];
                        x.funds = [];
                        x.resourceLoading = false;
                    });
                    y.apis = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        async viewResource(y) {
            y.viewResource = !y.viewResource;
            if (y.resourceList.length == 0 && y.viewResource) {
                y.resourceLoading = true;
                await this.getFunds(y);
                await this.getResource(y);
                y.resourceLoading = false;
            }
        },
        async getFunds(row) {
            await this.$store
                .dispatch(
                    "financeTemplate/getDeliveryUnitFunds",
                    { cycle: this.$store.state.data.cycle, deliveryUnitId: row.planningTarget.deliveryUnitId }
                )
                .then((res) => {
                    row.loadingResources = false;
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.forEach((item) => {
                        item.fundClass = item.fundClassification.classification;
                        item.fundSource = item.sourceName;
                        item.accountGroup = item.groupName;
                    });
                    row.funds = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        async getResource(y) {
            await this.$store
                .dispatch(
                    "planningapiresource/GetPlanningApiResourcesByApi",
                    y.id
                )
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, 'error')
                    }
                    res.data.map((item) => {
                        item.totalQuantity = 0;
                        item.q1 = 0;
                        item.q2 = 0;
                        item.q3 = 0;
                        item.q4 = 0;
                        item.planningApiResourceDetails.forEach((z) => {
                            item.totalQuantity += z.quantity;
                            if (z.monthId == 1 || z.monthId == 2 || z.monthId == 3) {
                                item.q1 += z.quantity;
                            } else if (z.monthId == 4 || z.monthId == 5 || z.monthId == 6) {
                                item.q2 += z.quantity;
                            } else if (z.monthId == 7 || z.monthId == 8 || z.monthId == 9) {
                                item.q3 += z.quantity;
                            } else if (z.monthId == 10 || z.monthId == 11 || z.monthId == 12) {
                                item.q4 += z.quantity;
                            }
                        });
                        let budgetInfo = y.funds.find(
                            (x) => x.id == item.financeTemplateBudgetItemId
                        );
                        item.financeTemplate = {
                            fundSource: budgetInfo.fundSource,
                            fundClass: budgetInfo.fundClass,
                            accountGroup: budgetInfo.groupName,
                            accountId: budgetInfo.accountGroupId,
                        };
                    });
                    y.resourceList = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        returnOPCR(row) {
            this.$emit('return-opcr', row)
        },
        async approvePlanning(id) {
            return await this.$store.dispatch("preopcr/ApprovePlanningOPCR", id).then((res) => {
                if (res.data.error) {
                    return { success: false, message: res.data.errorMessage };
                }
                return { success: true, message: '' };
            })
                .catch((err) => {
                    return { success: false, message: err };
                });
        },
        async approveOVP(id) {
            return await this.$store
                .dispatch("preopcr/ApproveOPCR", id)
                .then((res) => {
                    if (res.data.error) {
                        return { success: false, message: res.data.errorMessage };
                    }
                    return { success: true, message: '' };
                })
                .catch((err) => {
                    return { success: false, message: err };
                });
        },
        async approvePresident(id) {
            return await this.$store
                .dispatch("preopcr/ImportOPCR", id)
                .then((res) => {
                    if (res.data.error) {
                        return { success: false, message: res.data.errorMessage };
                    }
                    return { success: true, message: '' };
                })
                .catch((err) => {
                    return { success: false, message: err };
                });
        },
        approveOPCR(opcr) {
            Swal.fire({
                title: "Are you sure?",
                text: "You want to approve this OPCR?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, approve it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store
                        .dispatch("preopcr/ApproveFinanceOPCR", opcr.id)
                        .then(async (res) => {
                            if (res.data.error) {
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            if (this.$store.state.data.cycle == 2023) {
                                let appPlanning = await this.approvePlanning(opcr.id)
                                if (!appPlanning.success) {
                                    return this.showToast(appPlanning.message, "error");
                                }
                                let appOVP = await this.approveOVP(opcr.id)
                                if (!appOVP.success) {
                                    return this.showToast(appOVP.message, "error");
                                }
                                let appPresident = await this.approvePresident(opcr.id)
                                if (!appPresident.success) {
                                    return this.showToast(appPresident.message, "error");
                                }
                                this.showToast("OPCR successfully posted!", "success");
                            } else {
                                this.showToast("Successfully approved", "success");
                            }
                            this.removeOPCR(opcr.id)
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        printPPMPAPI(id, type) {
            this.$emit('print-ppmp-api', { id, type })
        },
        printPPMP(id, type) {
            this.$emit('print-ppmp', { id, type })
        },
        printDULIB(id) {
            this.$emit('print-du-lib', id)
        },
        printOPCR(id, type) {
            this.$emit('print-opcr', { id, type })
        },
        printLIB(ev) {
            this.$emit('printLIB', ev);
        },
        printPRE(ev) {
            this.$emit('printPRE', ev);
        },
        printAPP() {
            this.$emit('printAPP');
        },
        removeOPCR(id) {
            let index = this.opcrs.findIndex(x => x.id == id);
            this.opcrs.splice(index, 1);
            let duIndex = this.selectedDU.opcrs.findIndex(x => x.id == id);
            this.selectedDU.opcrs.splice(duIndex, 1);
            this.selectedDU.count--;
        },
        viewLogs(row) {
            this.$emit("viewLogs", row);
        },
        viewItems(row) {
            this.$emit("viewItems", row);
        },
        importThisAPI(api) {
            this.$emit('import-api', api)
        },
        filteredAPI(data, search) {
            if (search.trim() != "" && search) {
                data = data.filter((item) => {
                    return item.name.toUpperCase().includes(search.toUpperCase());
                });
            }
            return data;
        },
        async selectTab(number) {
            this.selectedTab = number;
            if (number == 1 && this.libs.length == 0) {
                this.loadLib = true;
                await this.getDULibs(this.selectedDU);
                this.loadLib = false;
            }
        },
        allocatedToDepartment(accountGrp) {
            this.$emit('allocated-departments', accountGrp)
        },
    }
}
</script>
<template>
    <div>
        <div v-if="!selectedDU">
            <div class="d-flex align-items-center justify-content-between">
                <div id="tickets-table_filter" class="dataTables_filter me-1">
                    <label class="d-inline-flex align-items-center mb-0">
                        <b-form-input autocomplete="off" v-model.lazy="filterDUs" type="search"
                            placeholder="Search Delivery Unit..." class="form-control"></b-form-input>
                    </label>
                </div>
                <LibPreReportBtn :reportId="forApproval ? 1 : 2" reportFrom="finance" @printAPP="printAPP"
                    @printPRE="printPRE" @printLIB="printLIB" />
            </div>
            <div class="my-3">
                <div v-if="campusBusy">
                    <h3>Loading...</h3>
                </div>
                <div v-if="items.length == 0 && !campusBusy">
                    <h3>No data found...</h3>
                </div>
                <div v-if="items.length && filtered.length == 0">
                    <h3>Search not found</h3>
                </div>
                <div v-if="items.length">
                    <div role="tablist" v-for="x in filtered" :key="x.id">
                        <b-card no-body class="mb-2 shadow-none">
                            <b-card-header header-tag="header" role="tab" header-class="cursor-pointer"
                                @click="viewOPCRs(x)">
                                <div class="
                                        d-flex
                                        justify-content-between
                                        align-items-center
                                    ">
                                    <h6 class="m-0">
                                        <a class="text-dark py-2" href="javascript: void(0);">
                                            &nbsp;
                                            <p class="text-info font-size-16"
                                                :class="{ 'mb-2': x.deliveryUnit.signatory, 'mb-0': !x.deliveryUnit.signatory }">
                                                {{ x.deliveryUnit.name }} [{{ x.count }}]</p>
                                            <div v-if="x.deliveryUnit.signatory">
                                                <span class="text-white">{{ x.deliveryUnit.signatory }} {{ `
                                                    (${x.deliveryUnit.position})` }}</span>
                                            </div>
                                        </a>
                                    </h6>
                                    <div class="
                                            d-flex
                                            align-items-center
                                        ">
                                        <div>
                                            <span class="
                                                    d-flex
                                                    align-items-center
                                                    text-truncate
                                                ">
                                                <small v-if="!x.rotateChevy">Click to view OPCRs</small>
                                                <i class="bx bx-chevron-right rotate font-size-18 ms-3"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </b-card-header>
                        </b-card>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="row my-2">
                <div class="col-sm-12 col-md-6">
                    <div class="d-flex">
                        <a href="javascript:void(0);" @click="selectedDU = null;"
                            class="font-size-20 font-weight-bold me-2"><i class="bx bx-arrow-back"></i></a>
                        <div class="d-flex gap-1">
                            <h4 class="card-title mb-0 d-flex align-items-center">{{ selectedDU.deliveryUnit.name }}'s
                                OPCR(s)</h4>
                            <div class="d-flex gap-1">
                                <div class="border px-3 py-1 cursor-pointer"
                                    :class="{ 'bg-purple text-white': selectedTab == 0 }" @click="selectTab(0)">
                                    OPCRs
                                </div>
                                <div class="border px-3 py-1 cursor-pointer"
                                    :class="{ 'bg-pink text-white': selectedTab == 1 }" @click="selectTab(1)">
                                    Line Item Budget
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-sm-12 col-md-6" v-if="selectedTab == 0">
                    <div id="tickets-table_filter" class="
                            dataTables_filter
                            text-md-end
                        ">
                        <label class="
                                d-inline-flex
                                align-items-center
                                mb-0
                            ">
                            <b-form-input autocomplete="off" v-model="searchOPCR" type="search"
                                placeholder="Search OPCR..." class="
                                    form-control
                                    form-control-sm
                                    mx-2
                                "></b-form-input>
                        </label>
                    </div>
                </div>
            </div>
            <template v-if="selectedTab == 0">
                <div role="tablist" v-for="(opcr, opcrIndex) in filteredOPCR" :key="opcr.id">
                    <b-card no-body class="mb-2 shadow-none position-relative"
                        :style="{ 'z-index': filteredOPCR.length - opcrIndex }">
                        <RawData :data="opcr" v-if="$store.state.decrypt.isAdmin()" />
                        <b-card-header header-tag="header" role="tab" header-class="cursor-pointer border px-0">
                            <div class="d-flex justify-content-between px-3">
                                <div>
                                    <div class="font-size-16">
                                        {{ opcr.title }}
                                        <!-- <span 
                                            class="font-weight-bold" 
                                            :class="{
                                                'text-green':opcr.status.toUpperCase().includes('POSTED'),
                                                'text-warning':opcr.status.toUpperCase().includes('RETURN'),
                                                'text-success':opcr.status.toUpperCase().includes('APPROVE'),
                                            }">
                                            [{{opcr.status}}]
                                        </span> -->
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <a href="javascript:void(0);" class="text-green d-flex align-items-center gap-1"
                                            @click="viewApis(opcr)">{{ opcr.showApis ? 'Hide' : 'Show' }} API(s) <i
                                                class="bx rotate bx-chevrons-right"
                                                :class="{ 'rotate-90': opcr.showApis }"></i></a>
                                        <!-- <span class="mx-2">|</span>
                                        <a href="javascript:void(0);" class="text-pink d-flex align-items-center gap-1" @click="viewLibs(opcr)">{{opcr.showLibs ? 'Hide' : 'Show'}} LIB(s) <i class="bx rotate bx-chevrons-right" :class="{'rotate-90': opcr.showLibs}"></i></a>  -->
                                    </div>
                                </div>
                                <div>
                                    <button type="button" class="btn btn-sm btn-secondary me-2"
                                        @click="viewLogs(opcr)"><i class="bx bx-receipt"></i> View Logs</button>
                                    <b-dropdown id="dropdown-dropleft" right variant="purple btn-sm"
                                        toggle-class="text-decoration-none" menu-class="dropdown-menu-end" no-caret>
                                        <template #button-content>
                                            <i class="bx bx-printer me-1"></i> Reports
                                        </template>
                                        <!-- <b-dropdown-item @click="printWFP()" v-if="$store.state.data.selectedCampus.isExternal">WFP </b-dropdown-item> -->
                                        <!-- <b-dropdown-item @click="printOPCR(opcr.id, 4)">OPCR v4</b-dropdown-item>
                                        <b-dropdown-item @click="printOPCR(opcr.id, 3)">OPCR v3</b-dropdown-item> -->
                                        <b-dropdown-item @click="printOPCR(opcr.id, 2)">
                                            OPCR
                                            <!-- v2 -->
                                        </b-dropdown-item>
                                        <!-- <b-dropdown-item @click="printOPCR(opcr.id, 1)">OPCR</b-dropdown-item> -->
                                        <b-dropdown-item @click="printDULIB(opcr.id)">LIB</b-dropdown-item>
                                        <!-- <b-dropdown-item @click="printPPMP(opcr.id, 1)">PPMP</b-dropdown-item> -->
                                        <b-dropdown-item @click="printPPMP(opcr.id, 2)">
                                            PPMP
                                            <!-- (v2) -->
                                        </b-dropdown-item>
                                    </b-dropdown>
                                    <button v-if="forApproval" type="button" class="btn btn-sm btn-warning mx-2"
                                        @click="returnOPCR(opcr)"><i class="bx bx-chevrons-left"></i> Return
                                        LIB</button>
                                    <button v-if="forApproval" type="button" class="btn btn-sm btn-success"
                                        @click="approveOPCR(opcr)"><i class="bx bx-check"></i> Approve LIB</button>
                                    <button v-if="!forApproval && opcr.status.toUpperCase().includes('POSTED')"
                                        type="button" class="btn btn-sm btn-warning ms-2" @click="returnOPCR(opcr)"><i
                                            class="bx bx-chevrons-left"></i> Revert
                                        LIB</button>
                                </div>
                            </div>
                        </b-card-header>
                        <b-collapse :visible="opcr.showApis" :accordion="`opcr-${opcr.id}`" role="tabpanel">
                            <b-card-body>
                                <template v-if="opcr.loadApi">Loading...</template>
                                <template v-if="!opcr.loadApi && !opcr.apis.length">
                                    <h4 class="mb-0">No data found.</h4>
                                </template>
                                <template v-if="!opcr.loadApi && opcr.apis.length">
                                    <div class="d-flex justify-content-between">
                                        <h4 class="mb-0">API List</h4>
                                        <input type="search" v-model="opcr.apiSearch" class="form-control"
                                            placeholder="Search API..." style="width:300px;">
                                    </div>
                                    <div class="row mt-2" v-if="!opcr.apiLoading && opcr.apis.length">
                                        <div class="col-md-12">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>API Description</th>
                                                        <th width="220px">Total Resources</th>
                                                        <th width="90px" class="text-center">
                                                            Action
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <template v-for="api in filteredAPI(opcr.apis, opcr.apiSearch)">
                                                        <tr :key="`apis-z${api.id}-w${opcr.id}`">
                                                            <td class="position-relative">
                                                                <RawData :data="api"
                                                                    v-if="$store.state.decrypt.isAdmin()" />
                                                                <div>
                                                                    <a href="javascript:void(0);" class="text-white"
                                                                        @click="viewResource(api)">{{ api.name }}</a>
                                                                </div>
                                                                <div>
                                                                    <small class="text-warning cursor-pointer"
                                                                        @click="viewResource(api)">View
                                                                        Resources</small>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                {{ formatCurrency(api.total) }}
                                                            </td>
                                                            <td class="align-middle">
                                                                <div
                                                                    class="d-flex justify-content-center align-items-center">
                                                                    <button type="button" @click="importThisAPI(api)"
                                                                        class="btn btn-clear px-1" title="Import API"
                                                                        v-if="!forApproval && !api.imported && (!opcr.imported || $store.state.decrypt.isAdmin()) && ((opcr.financeStatus && opcr.financeStatus.toUpperCase().includes('APPROVE')) || $store.state.data.selectedCampus.isExternal)">
                                                                        <i
                                                                            class="bx bx-upload text-info font-size-18"></i>

                                                                    </button>
                                                                    <div class="float-end">
                                                                        <b-dropdown id="dropdown-dropleft" right
                                                                            variant="link"
                                                                            toggle-class="text-decoration-none"
                                                                            menu-class="dropdown-menu-end" no-caret>
                                                                            <template #button-content>
                                                                                <i
                                                                                    class="bx bx-printer font-size-18"></i>
                                                                            </template>
                                                                            <b-dropdown-item
                                                                                @click="printPPMPAPI(api.id, 1)"
                                                                                variant="dark">
                                                                                Print PPMP
                                                                            </b-dropdown-item>
                                                                            <b-dropdown-item
                                                                                @click="printPPMPAPI(api.id, 2)"
                                                                                variant="dark">
                                                                                Print PPMP (v2)
                                                                            </b-dropdown-item>
                                                                        </b-dropdown>
                                                                    </div>
                                                                </div>
                                                                <div v-if="api.imported">Imported</div>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="api.viewResource"
                                                            :key="`apisRrs-z${api.id}-w${opcr.id}`">
                                                            <td colspan="4" v-if="
                                                                !api.resourceLoading &&
                                                                api.resourceList.length == 0
                                                            " class="broken-border text-center">
                                                                No data found
                                                            </td>
                                                            <td colspan="4" v-if="api.resourceLoading"
                                                                class="broken-border text-center">
                                                                Loading...
                                                            </td>
                                                            <td colspan="4" v-if="
                                                                !api.resourceLoading &&
                                                                api.resourceList.length > 0
                                                            ">
                                                                <div v-for="apiResource in api.resourceList"
                                                                    :key="`resourceList-z${api.id}-w${opcr.id}-a${apiResource.id}`"
                                                                    class="ms-3 mb-1 p-3 broken-border position-relative">
                                                                    <RawData :data="apiResource"
                                                                        v-if="$store.state.decrypt.isAdmin()" />
                                                                    <div
                                                                        class="d-flex align-items-center justify-content-between">
                                                                        <div class="d-flex align-items-center">
                                                                            <div class="font-size-20 text-yellow">
                                                                                {{ apiResource.totalQuantity }} {{
                                                                                    apiResource.unit.shortName }}
                                                                            </div>
                                                                            <i
                                                                                class="bx bx-x font-size-20 me-2 text-yellow"></i>
                                                                            <div>
                                                                                {{ apiResource.itemName }}
                                                                                <div>
                                                                                    <small>{{
                                                                                        apiResource.description
                                                                                        }}</small>
                                                                                    <small class="text-warning ms-1">[{{
                                                                                        apiResource.isProcurable ?
                                                                                            'Procurable' :
                                                                                            'Non-Procurable' }}]</small>
                                                                                    <small v-if="apiResource.isMixed"
                                                                                        class="text-warning ms-1">[Mixed]</small>
                                                                                </div>
                                                                                <div class="
                                                                            d-flex
                                                                            align-items-center
                                                                            mt-1
                                                                        ">
                                                                                    <span class="
                                                                                badge
                                                                                bg-secondary
                                                                                text-white
                                                                                py-1
                                                                                px-2
                                                                                me-2
                                                                            ">{{
                                                                                apiResource
                                                                                    .financeTemplate
                                                                                    .fundSource
                                                                                        }}</span>
                                                                                    <span class="
                                                                                badge
                                                                                bg-purple
                                                                                text-white
                                                                                py-1
                                                                                px-2
                                                                                me-2
                                                                            ">{{
                                                                                apiResource
                                                                                    .financeTemplate
                                                                                    .fundClass
                                                                                        }}</span>
                                                                                    <span class="
                                                                                badge
                                                                                bg-success
                                                                                text-white
                                                                                py-1
                                                                                px-2
                                                                                me-2
                                                                            ">{{
                                                                                apiResource
                                                                                    .financeTemplate
                                                                                    .accountGroup
                                                                                        }}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="text-center">
                                                                            <div class="font-size-20 text-yellow mb-0">
                                                                                {{
                                                                                    formatCurrency(apiResource.totalWithInflation)
                                                                                }}
                                                                            </div>
                                                                            <small>({{ formatCurrency(
                                                                                apiResource.unitCost) }})</small>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </template>
                            </b-card-body>
                        </b-collapse>
                        <!-- <b-collapse
                            :visible="opcr.showLibs"
                            :accordion="`opcr-lib-${opcr.id}`"
                            role="tabpanel"
                        >
                            <div class="table-responsive">
                                <table
                                    class="
                                        table
                                        project-list-table
                                        table-centered table-borderless
                                        align-middle
                                    "
                                >
                                    <thead>
                                        <tr>
                                            <th
                                                scope="col"
                                                width="50px"
                                            ></th>
                                            <th scope="col">Description</th>
                                            <th scope="col" width="250px">
                                                Budget Allocated
                                            </th>
                                            <th scope="col" width="250px">
                                                Total Resources
                                            </th>
                                            <th scope="col" width="250px">
                                                Balance
                                            </th>
                                            <th scope="col" width="90px">
                                                Action
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="opcr.loadLib">
                                            <td colspan="100%">
                                                <div class="d-flex justify-content-center align-items-center">
                                                    <div class="preloader-component me-2">
                                                        <div class="status">
                                                            <div class="spinner-chase w-20px h-20px">
                                                                <div class="chase-dot"></div>
                                                                <div class="chase-dot"></div>
                                                                <div class="chase-dot"></div>
                                                                <div class="chase-dot"></div>
                                                                <div class="chase-dot"></div>
                                                                <div class="chase-dot"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <strong>Loading...</strong>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-if="opcr.libs.length == 0 && !opcr.loadLib">
                                            <td
                                                colspan="100%"
                                                class="text-muted text-center"
                                            >
                                                <i class="dripicons-warning me-1"></i>No data found
                                            </td>
                                        </tr>
                                        <template
                                            v-for="fundSource in opcr.libs"
                                        >
                                            <tr
                                                :key="'A' + fundSource.id"
                                                style="
                                                    background-color: transparent;
                                                    box-shadow: none;
                                                "
                                            >
                                                <td
                                                    colspan="2"
                                                    class="py-0"
                                                >
                                                    <div
                                                        class="
                                                            d-flex
                                                            align-items-center
                                                        "
                                                    >
                                                        <span
                                                            class="
                                                                bx bx-star
                                                                text-warning
                                                                me-1
                                                            "
                                                            style="
                                                                line-height: unset;
                                                            "
                                                        ></span>
                                                        <h5
                                                            class="
                                                                text-dark
                                                                mb-0
                                                                me-2
                                                            "
                                                        >
                                                            {{ fundSource.fsName }}
                                                        </h5>
                                                    </div>
                                                </td>
                                                <td class="text-warning font-size-14">
                                                    {{ formatCurrency(fundSource.allocated) }}
                                                </td>
                                                <td class="text-warning font-size-14">
                                                    {{ formatCurrency(fundSource.allocated - fundSource.balance) }}
                                                </td>
                                                <td class="text-warning font-size-14">
                                                    {{ formatCurrency(fundSource.balance) }}
                                                </td>
                                                <td></td>
                                            </tr>
                                            <template v-for="fundClass in fundSource.data">
                                                <tr
                                                    :key="'A' + fundSource.id + 'B' + fundClass.id"
                                                    style="
                                                        background-color: transparent;
                                                        box-shadow: none;
                                                    "
                                                >
                                                    <td
                                                        colspan="100%"
                                                        class="p-0-20p"
                                                    >
                                                        <div
                                                            class="
                                                                d-flex
                                                                align-item-center
                                                            "
                                                        >
                                                            <span
                                                                class="
                                                                    bx
                                                                    bx-checkbox-square
                                                                    text-success
                                                                    me-1
                                                                "
                                                                style="
                                                                    line-height: unset;
                                                                "
                                                            ></span>
                                                            <b
                                                                class="
                                                                    text-dark
                                                                "
                                                                >{{
                                                                    fundClass.key
                                                                }}</b
                                                            >
                                                        </div>
                                                    </td>
                                                </tr>
                                                <template
                                                    v-for="(accountGrp, accGrpIndex) in fundClass.data"
                                                >
                                                    <tr
                                                        :key="'A' + fundSource.id + 'B' + fundClass.id + 'C' + accGrpIndex"
                                                        style="
                                                            background-color: transparent;
                                                        "
                                                    >
                                                        <td>
                                                        </td>
                                                        <td
                                                            class="
                                                                bg-table-tr
                                                                position-relative
                                                            "
                                                        >
                                                            <h5
                                                                class="
                                                                    text-truncate
                                                                    font-size-14
                                                                    mb-0
                                                                    d-flex
                                                                "
                                                            >
                                                                <a
                                                                    href="javascript: void(0);"
                                                                    class="
                                                                        text-dark
                                                                    "
                                                                    @click="
                                                                        viewItems(
                                                                            accountGrp
                                                                        )
                                                                    "
                                                                    >{{
                                                                        accountGrp
                                                                            .financeTemplateObjectOfExpenditure
                                                                            .accountGroup
                                                                            .groupName
                                                                    }}</a
                                                                >
                                                            </h5>
                                                            <small
                                                                v-if="accountGrp.manuallyAddedByDeliveryUnit"
                                                                class="text-warning"
                                                            >
                                                                Manually added by Delivery Unit
                                                            </small>
                                                        </td>
                                                        <td
                                                            class="
                                                                bg-table-tr
                                                            "
                                                        >
                                                            {{
                                                                formatCurrency(
                                                                    accountGrp.amount
                                                                )
                                                            }}
                                                        </td>
                                                        <td
                                                            class="
                                                                bg-table-tr
                                                            "
                                                        >
                                                            {{
                                                                formatCurrency(
                                                                    accountGrp.totalUsed
                                                                )
                                                            }}
                                                        </td>
                                                        <td
                                                            class="
                                                                bg-table-tr
                                                            "
                                                        >
                                                            <div>
                                                                {{
                                                                    formatCurrency(
                                                                        accountGrp.balance
                                                                    )
                                                                }}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <i class="bx bx-receipt cursor-pointer" title="View Items" @click="viewItems(accountGrp)"></i>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </template>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </b-collapse> -->
                    </b-card>
                </div>
            </template>
            <template v-else>
                <div class="table-responsive">
                    <table class="
                            table
                            project-list-table
                            table-centered table-borderless
                            align-middle
                        ">
                        <thead>
                            <tr>
                                <th scope="col" width="50px"></th>
                                <th scope="col">Description</th>
                                <th scope="col" width="250px">Budget Allocated</th>
                                <th scope="col" width="250px">Total Resources</th>
                                <th scope="col" width="250px">Department Allocation</th>
                                <th scope="col" width="250px">Balance</th>
                                <th scope="col" width="90px">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="loadLib">
                                <td colspan="100%">
                                    <div class="d-flex justify-content-center align-items-center">
                                        <div class="preloader-component me-2">
                                            <div class="status">
                                                <div class="spinner-chase w-20px h-20px">
                                                    <div class="chase-dot"></div>
                                                    <div class="chase-dot"></div>
                                                    <div class="chase-dot"></div>
                                                    <div class="chase-dot"></div>
                                                    <div class="chase-dot"></div>
                                                    <div class="chase-dot"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <strong>Loading...</strong>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="libs.length == 0 && !loadLib">
                                <td colspan="100%" class="text-muted text-center">
                                    <i class="dripicons-warning me-1"></i>No data found
                                </td>
                            </tr>
                            <template v-for="fundSource in libs">
                                <tr :key="'A' + fundSource.id" style="
                                        background-color: transparent;
                                        box-shadow: none;
                                    ">
                                    <td colspan="2" class="py-0">
                                        <div class="
                                                d-flex
                                                align-items-center
                                            ">
                                            <span class="
                                                    bx bx-star
                                                    text-warning
                                                    me-1
                                                " style="
                                                    line-height: unset;
                                                "></span>
                                            <h5 class="
                                                    text-dark
                                                    mb-0
                                                    me-2
                                                ">
                                                {{ fundSource.fsName }}
                                            </h5>
                                        </div>
                                    </td>
                                    <td class="text-warning font-size-14">
                                        {{ formatCurrency(fundSource.allocated) }}
                                    </td>
                                    <td class="text-warning font-size-14">
                                        {{ formatCurrency(fundSource.allocated - fundSource.balance) }}
                                    </td>
                                    <td class="font-size-14">
                                        {{ formatCurrency(fundSource.departmentAlloc) }}
                                    </td>
                                    <td class="text-warning font-size-14">
                                        {{ formatCurrency(fundSource.balance) }}
                                    </td>
                                    <td></td>
                                </tr>
                                <template v-for="fundClass in fundSource.data">
                                    <tr :key="'A' + fundSource.id + 'B' + fundClass.id" style="
                                            background-color: transparent;
                                            box-shadow: none;
                                        ">
                                        <td colspan="100%" class="p-0-20p">
                                            <div class="
                                                    d-flex
                                                    align-item-center
                                                ">
                                                <span class="
                                                        bx
                                                        bx-checkbox-square
                                                        text-success
                                                        me-1
                                                    " style="
                                                        line-height: unset;
                                                    "></span>
                                                <b class="
                                                        text-dark
                                                    ">{{
                                                        fundClass.key
                                                    }}</b>
                                            </div>
                                        </td>
                                    </tr>
                                    <template v-for="(accountGrp, accGrpIndex) in fundClass.data">
                                        <tr :key="'A' + fundSource.id + 'B' + fundClass.id + 'C' + accGrpIndex" style="
                                                background-color: transparent;
                                                box-shadow: none;
                                            ">
                                            <td>
                                            </td>
                                            <td class="
                                                    bg-table-tr
                                                    position-relative
                                                ">
                                                <h5 class="
                                                        text-truncate
                                                        font-size-14
                                                        mb-0
                                                        d-flex
                                                    ">
                                                    <a href="javascript: void(0);" class="text-dark"
                                                        @click="viewItems(accountGrp)">{{ accountGrp.groupName }}
                                                    </a>
                                                </h5>
                                                <small v-if="accountGrp.manuallyAddedByDeliveryUnit"
                                                    class="text-warning">
                                                    Manually added by Delivery Unit
                                                </small>
                                            </td>
                                            <td class="bg-table-tr">
                                                {{ formatCurrency(accountGrp.amount) }}
                                            </td>
                                            <td class="bg-table-tr">
                                                {{ formatCurrency(accountGrp.totalUsed +
                                                    accountGrp.cascadedUsedImported) }}
                                                <div v-if="accountGrp.cascadedUsedImported > 0">
                                                    <small class="d-block">DU: <span>{{
                                                        formatCurrency(accountGrp.totalUsed) }}</span></small>
                                                    <small class="d-block">Department: <span>{{
                                                        formatCurrency(accountGrp.cascadedUsedImported)
                                                            }}</span></small>
                                                </div>
                                            </td>
                                            <td class="bg-table-tr">
                                                <b>{{ formatCurrency(accountGrp.cascadedFunds) }}</b>
                                                <div v-if="accountGrp.cascadedUsed != 0">
                                                    <small class="d-block">Used: <span class="text-yellow">{{
                                                        formatCurrency(accountGrp.cascadedUsed) }}</span></small>
                                                    <small class="d-block">Balance: <span class="text-green">{{
                                                        formatCurrency(accountGrp.cascadedFunds -
                                                            accountGrp.cascadedUsed) }}</span></small>
                                                    <small class="d-block">Imported: <span class="text-info">{{
                                                        formatCurrency(accountGrp.cascadedUsedImported)
                                                            }}</span></small>
                                                </div>
                                            </td>
                                            <td class="bg-table-tr">
                                                <div>{{ formatCurrency(accountGrp.balance) }}</div>
                                            </td>
                                            <td class="bg-table-tr">
                                                <i class="bx bx-receipt cursor-pointer font-size-18" title="View Items"
                                                    @click="viewItems(accountGrp)"></i>
                                                <i class="mdi mdi-transfer cursor-pointer font-size-18 ms-2 text-green"
                                                    title="Allocated Departments"
                                                    @click="allocatedToDepartment(accountGrp)"></i>
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                            </template>
                        </tbody>
                    </table>
                </div>
            </template>
        </div>
    </div>
</template>